module.exports = __webpack_public_path__ + "img/pdmu_stem.493502ab.png";